var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-form ic-form header-form itinerary-form dark-form",
      class: _vm.mainFormContainer,
    },
    [
      _c(
        "form",
        {
          staticClass: "jsStationAlerts",
          attrs: {
            role: "form",
            name: "searchTrain",
            method: "post",
            action: _vm.action,
            autocomplete: "off",
            id: "searchTrainForm",
          },
        },
        [
          _vm._t("extra"),
          _vm._v(" "),
          _c("div", { staticClass: "row gx-lg-5 py-3" }, [
            _c(
              "div",
              { staticClass: "col-12 justify-content-between d-flex" },
              [
                _c("h3", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("ic_new_gdzie_dzis_jedziemy")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isAdvancedViewActive &&
                        !_vm.forceAdvView &&
                        !_vm.isSimpleViewActive,
                      expression:
                        "(isAdvancedViewActive && !forceAdvView) && !isSimpleViewActive ",
                    },
                  ],
                  staticClass: "btn-close btn-close-white",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.hideAdvView.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isMobile && _vm.isSimpleViewActive,
                      expression: "(isMobile && isSimpleViewActive)",
                    },
                  ],
                  staticClass: "btn-close btn-close-white",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.hideSimpleView.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMobile && _vm.isSimpleViewActive,
                      expression: "(!isMobile && isSimpleViewActive)",
                    },
                  ],
                  staticClass: "btn-close btn-close-white",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.hideSimpleViewDesktop.apply(null, arguments)
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { class: _vm.destinations }, [
              _c(
                "div",
                { staticClass: "typehead-container mb-3" },
                [
                  _vm._t("destination-from", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "start no-border",
                          attrs: {
                            role: "combobox",
                            "aria-haspopup": "listbox",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              staticClass:
                                "jsStationTypeaheadItem jsNearestStationItem form-control",
                              attrs: {
                                type: "search",
                                id: "stname-0",
                                name: "stname[0]",
                                placeholder: "np. Warszawa Centralna",
                                autocomplete: "off",
                                role: "searchbox",
                                "aria-multiline": "false",
                                "aria-autocomplete": "list",
                              },
                              domProps: { value: _vm.stname0 },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "jsTypeaheadItem-Value",
                              attrs: {
                                type: "hidden",
                                name: "stid[0]",
                                id: "stid-0",
                              },
                              domProps: { value: _vm.stid0 },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _vm._v(
                                "\n                        SKĄD\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "switch d-flex h-100 align-items-center focus",
                      attrs: { tabindex: "0" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.reverse.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "bi bi-arrow-down-up" }),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Zamień stację odjazdu ze stacją przyjazdu."),
                      ]),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isAdvancedViewActive,
                      expression: "isAdvancedViewActive",
                    },
                  ],
                  staticClass: "typehead-container mb-3",
                },
                [
                  _vm._t("destination-via", function () {
                    return [_vm._m(0)]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "typehead-container mb-3" },
                [
                  _vm._t("destination-to", function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "end no-border",
                          attrs: {
                            role: "combobox",
                            "aria-haspopup": "listbox",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              staticClass:
                                "jsStationTypeaheadItem jsNearestStationItem form-control",
                              attrs: {
                                type: "search",
                                id: "stname-1",
                                name: "stname[1]",
                                placeholder: "np. Szczecin Gł.",
                                autocomplete: "off",
                                role: "searchbox",
                                "aria-multiline": "false",
                                "aria-autocomplete": "list",
                              },
                              domProps: { value: _vm.stname1 },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "jsTypeaheadItem-Value",
                              attrs: {
                                type: "hidden",
                                name: "stid[1]",
                                id: "stid-1",
                              },
                              domProps: { value: _vm.stid1 },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _vm._v(
                                "\n                      DOKĄD\n                "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.timeDetails }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isAdvancedViewActive,
                      expression: "isAdvancedViewActive",
                    },
                  ],
                  staticClass: "mb-3",
                },
                [
                  _vm._t("time-details-slot", function () {
                    return [
                      _c("fieldset", [
                        _c("legend", { staticClass: "sr-only" }, [
                          _vm._v("Lorem ipsum"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-check form-check-inline" },
                          [
                            _c("input", {
                              ref: "extra1",
                              staticClass: "form-check-input",
                              attrs: {
                                type: "radio",
                                name: "arr",
                                id: "inlineRadio1",
                                value: "1",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "inlineRadio1" },
                              },
                              [_vm._v("Przyjazd")]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(1),
                      ]),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _vm._t("date-time-pickers", function () {
                    return [_c("date-time")]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isAdvancedViewActive,
                      expression: "isAdvancedViewActive",
                    },
                  ],
                  staticClass: "mb-3",
                },
                [
                  _vm._t("rodzaj-pociagu", function () {
                    return [_vm._m(2)]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAdvancedViewActive,
                    expression: "isAdvancedViewActive",
                  },
                ],
                staticClass: "col-12 col-lg-4",
              },
              [
                _vm._t("dodatkowe", function () {
                  return [_vm._m(3)]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row gy-5 pb-3" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "div",
                  { staticClass: "alerts" },
                  [
                    _vm._t("alerts-slot", function () {
                      return [_vm._m(4)]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row gy-5 gx-lg-5" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: 0 && _vm.isAdvancedViewActive,
                    expression: "0 && isAdvancedViewActive",
                  },
                ],
                staticClass: "col-12 col-md-4 justify-content-md-start history",
              },
              [_vm._m(5)]
            ),
            _vm._v(" "),
            _c("div", { class: _vm.searchBtn }, [
              _c("input", {
                staticClass: "jsVariable-HafasPage",
                attrs: {
                  type: "hidden",
                  name: "hafasPage",
                  value: "{$hafas_page}",
                },
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "jsVariable-HafasSort",
                attrs: { type: "hidden", name: "hafasSort", value: "" },
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "jsVariable-HafasSort",
                attrs: { type: "hidden", name: "search", value: "1" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "g-recaptcha",
                attrs: {
                  id: "recaptcha",
                  "data-tabindex": "99",
                  "data-sitekey": "6LfNgbIZAAAAAJRnN7xCoQZH-gq-fiMYFAoNxOcR",
                  "data-callback": "onSubmitSearchForm",
                  "data-action": "submit",
                  "data-size": "invisible",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-warning mb-2 w-100",
                  attrs: {
                    type: "submit",
                    name: "search",
                    value: "1",
                    onClick: "return grecaptcha.execute();",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("icsearch_wyszukaj")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.forceAdvView
            ? _c("p", [
                _c(
                  "a",
                  {
                    ref: "advToggle",
                    staticClass: "btn-link btn-adv-search focus",
                    attrs: {
                      href: "#",
                      "aria-expanded": _vm.isAdvancedViewActive.toString(),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleAdvView.apply(null, arguments)
                      },
                    },
                  },
                  [
                    !_vm.isAdvancedViewActive
                      ? [
                          _vm._v(
                            _vm._s(_vm.$t("icsearch_wyszukiwarka_szczegolowa"))
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAdvancedViewActive
                      ? [
                          _vm._v(
                            _vm._s(_vm.$t("icsearch_wyszukiwarka_standard"))
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [_vm._t("dev")], 2),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "multiple-dest no-border",
        attrs: {
          role: "combobox",
          "aria-haspopup": "listbox",
          "aria-expanded": "false",
        },
      },
      [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            staticClass:
              "jsStationTypeaheadItem jsNearestStationItem form-control",
            attrs: {
              type: "search",
              id: "vianame-1",
              name: "vianame[1]",
              value: "",
              placeholder: "np. Poznań Gł.",
              autocomplete: "off",
              role: "searchbox",
              "aria-multiline": "false",
              "aria-autocomplete": "list",
            },
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "jsTypeaheadItem-Value",
            attrs: { type: "hidden", name: "vianame[0]", value: "" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _vm._v("\n                      PRZEZ\n                "),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-check form-check-inline" }, [
      _c("input", {
        staticClass: "form-check-input",
        attrs: {
          type: "radio",
          name: "arr",
          id: "inlineRadio2",
          value: "0",
          checked: "",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "form-check-label", attrs: { for: "inlineRadio2" } },
        [_vm._v("Odjazd")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("fieldset", [
      _c("legend", { staticClass: "sr-only" }, [_vm._v("Rodzaj pociągu")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            name: "category[]",
            id: "inlineCheckbox1",
            value: "eip",
            checked: "",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "inlineCheckbox1" },
          },
          [_vm._v("EIP")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            name: "category[]",
            id: "inlineCheckbox2",
            value: "eic",
            checked: "",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "inlineCheckbox2" },
          },
          [_vm._v("EIC")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            name: "category[]",
            id: "inlineCheckbox3",
            value: "icp",
            checked: "",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "inlineCheckbox3" },
          },
          [_vm._v("IC")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check form-check-inline" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            name: "category[]",
            id: "inlineCheckbox4",
            value: "tlk",
            checked: "",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "inlineCheckbox4" },
          },
          [_vm._v("TLK")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("fieldset", [
      _c("legend", { staticClass: "sr-only" }, [
        _vm._v("Wybierz dodatkowe opcje połączenia"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3 mtn" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "direct",
            id: "ic-seek-direct",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "ic-seek-direct" } },
          [
            _vm._v(
              "\n                              tylko połączenie bezpośrednie\n                          "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3 mtn" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "bike",
            id: "ic-seek-bike",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "ic-seek-bike" } },
          [
            _vm._v(
              "                                \n                               możliwość przewozu rowerów\n                          "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "couchette",
            id: "ic-seek-couchette",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "ic-seek-couchette" },
          },
          [
            _vm._v(
              "                                \n                               z miejscami do leżenia\n                          "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "sleeper",
            id: "ic-seek-sleeper",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "ic-seek-sleeper" },
          },
          [
            _vm._v(
              "                                \n                               z wagonami sypialnymi\n                          "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "disabled",
            id: "ic-seek-for_disabled",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "ic-seek-for_disabled" },
          },
          [
            _vm._v(
              "                                \n                               wagon z platformą/windą dla osób poruszających się na wózkach\n                          "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check mb-3" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            value: "1",
            name: "braille",
            id: "ic-seek-braille",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "ic-seek-braille" },
          },
          [
            _vm._v(
              "                                \n                               wagon z oznaczeniami w alfabecie Braille'a\n                          "
            ),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "alert alert-warning font-size-sm",
        attrs: { role: "alert" },
      },
      [
        _vm._v(
          "\n                W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących."
        ),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [
          _vm._v("Więcej informacji na temat obowiązujących zasad w podróży"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm",
          attrs: { type: "button", "aria-label": "Lorem ipsum" },
        },
        [_vm._v("Poznań główny - Gdańsk główny")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm",
          attrs: { type: "button", "aria-label": "Lorem ipsum" },
        },
        [_c("i", { staticClass: "bi bi-x-circle" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }